/**
 * 正規表現
 */
const _regExp = new Map([
  ["oneByOne", "(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])"], //半角全角英字+数字一つずつ
])

/**
 * 汎用ユーティルクラス 
 */
export default {
  data() {
    return {
      regExp: _regExp,
    }
  },
  methods: {
    eq: (o1, o2) => {
      return o1 == o2 ? true : false
    },
    notEq: (o1, o2) => {
      return o1 != o2 ? true : false
    },
    isEmpty: (o) => {
      if (typeof o == "string") {
        return o == null || o == "undefined" || o == "" ? true : false
      }
      else if (typeof o == "object") {
        return o == null ? true : false
      }
      else if (typeof o == "undefined") {
        return true
      }
      else if (typeof o == "number") {
        return false
      }
    },
    isNotEmpty: (o) => {
      if (typeof o == "string") {
        return o == null || o == "undefined" || o == "" ? false : true
      }
      else if (typeof o == "object") {
        return o == null ? false : true
      }
      else if (typeof o == "undefined") {
        return false
      }
      else if (typeof o == "number") {
        return true
      }
    },
    isMatch(s, type) {
      return s.match(this.regExp.get(type))
    },
    escapeNull: (o) => {
      if (o == null) {
        return ""
      }
      if (typeof o == "string" && (o == null || o == "undefined" || o == "")) {
        return ""
      }
      else if (typeof o == "object" && o == null) {
        return ""
      }
      else if (typeof o == "undefined") {
        return ""
      }
      else if (o == undefined) {
        return ""
      }
      return o
    },
    createBirthObj: (date) => {
      var obj = {
        year: date.getFullYear().toString(),
        month: ("0" + (date.getMonth() + 1)).slice(-2).toString(),
        day: ("0" + date.getDate()).slice(-2).toString(),
      }
      return obj
    },
    formatDateTime: (date, type) => {
      const y = date.getFullYear()
      const M = ("0" + (date.getMonth() + 1)).slice(-2)
      const d = ("0" + date.getDate()).slice(-2)
      const h = ("0" + date.getHours()).slice(-2)
      const m = ("0" + date.getMinutes()).slice(-2)
      switch (type) {
        case ("yyyy/MM/dd"):
          //"yyyy/MM/dd"
          return y + "/" + m + "/" + d
        case ("yyyy/MM/ddhh:mm"):
          //"yyyy/MM/dd hh:mm"
          return y + "/" + M + "/" + d + " " + h + ":" + m
        case ("MM-ddhhmm"):
          //"MM-dd hh:mm"
          return M + "-" + d + " " + h + ":" + m
        default:
          return null
      }
    },
    getPartners: async (db, type) => {
      let partners = [];
      let partnersSnapshot = await db
        .collection("partners")
        .where("type", "==", type)
        .get();
      if (!partnersSnapshot.empty) {
        partnersSnapshot.forEach((doc) => {
          var data = doc.data();
          partners.push({
            title: data.partnerName,
            img: data.imageUrl,
            alt: data.partnerName,
            url: data.url,
            pid: data.pid,
            descriptionEN: data.descriptionEN,
            descriptionJP: data.descriptionJP
          });
        });
      }
      return partners;
    },
    getCorrespondingPartnerForUser: async (db, partners, uid) => {
      let list = [];
      if (partners.length == 0) {
        return true;
      }
      let doc = await db.collection("users").doc(uid).get();
      if (doc.exists) {
        const data = doc.data();
        const pid = data.pid;
        let partner;
        if (pid !== undefined) {
          const partnerIdentification = pid.slice(4, 8);
          //let partner = partners.find((element) => element.pid == pid);
          partner = partners.find((element) => {
            const correspondingpartner = element.pid.slice(4, 8);
            return correspondingpartner == partnerIdentification;
          })
        }
        else {
          partner = undefined;
        }
        if (
          partner !== undefined &&
          partner.url !== "" &&
          partner.img !== undefined
        ) {
          // corresponding partner found for specific pid
          list.push(partner);
          return list;
        } else if (
          partner !== undefined &&
          (partner.url == "" ||
            partner.img == undefined || partner.img == "")
        ) {
          // corresponding partner found for pid but no url or img set yet
          // show coming soon
          //console.log("pid exist but no url and img");
          return true;
        } else {
          // Show all available partners
          partners.forEach((partner) => {
            if (partner.url !== "" && partner.img !== "") {
              list.push(partner);
            }
          });
          return list;
        }
      }
    }
  },
}